import React from 'react';
import { FlameIcon } from 'lucide-react';
export function AnnouncementBar() {
  return <div className="w-full bg-ink text-white" data-id="element-17" data-mp="ol21ltut6b1v">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2.5 text-center text-xs sm:text-sm" data-id="element-18" data-mp="olbvvtmvz4dd">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-sunshine px-3 py-1 font-semibold uppercase tracking-wide text-ink" data-id="element-19" data-mp="eva68xevxdwc">
          <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-20" data-mp="9wp5mwvq0s7d" />
          Offerta limitata
        </span>
        <span className="text-white/80" data-id="element-21" data-mp="5sr82qm1npgf">
          Prezzo speciale di lancio —{' '}
          <strong className="text-white" data-id="element-22" data-mp="w0rm26buruh">SCONTO DEL 50%</strong> solo oggi ·
          Download digitale immediato
        </span>
      </div>
    </div>;
}